import { render } from "./AgentDetails.vue?vue&type=template&id=3f644f20&scoped=true&ts=true"
import script from "./AgentDetails.vue?vue&type=script&lang=ts"
export * from "./AgentDetails.vue?vue&type=script&lang=ts"

import "./AgentDetails.vue?vue&type=style&index=0&id=3f644f20&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f644f20"]])

export default __exports__